import { render, staticRenderFns } from "./RoofCalAside.vue?vue&type=template&id=607aeeff&scoped=true"
import script from "./RoofCalAside.vue?vue&type=script&lang=js"
export * from "./RoofCalAside.vue?vue&type=script&lang=js"
import style0 from "./RoofCalAside.vue?vue&type=style&index=0&id=607aeeff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607aeeff",
  null
  
)

export default component.exports